<template>
  <el-tabs v-model="tabs.activeName" tab-position="left" @tab-click="tabClick">
    <el-tab-pane v-for="(item,i) in tabs.tabs" :key="`tab_${i}`" :name="String(item.id)" :label="item.name" lazy>
      <p class="title">一共<span>{{item.templateList?item.templateList.length:'0'}}</span>个素材</p>
      <el-scrollbar>
        <section v-html="item.text" @click="selectMaterial" class="material-item" v-for="(item,i) in item.templateList" :key="`material-item_${i}`" ></section>
      </el-scrollbar>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import axios from '@/common/utils/axios'
import { ElTabs, ElTabPane, ElScrollbar } from 'element-plus'
import { onMounted, reactive } from 'vue-demi'
import { inject } from 'vue'
export default {
  components: {
    ElTabs, ElTabPane, ElScrollbar
  },
  props: {
    groupList: {
      type: Array,
      default: () => []
    }
  },

  setup (props, context) {
    const tabs = reactive({
      activeName: props.groupList.length > 0 ? String(props.groupList[0].id) : '',
      tabs: props.groupList
    })

    /**
     * tab切换
     */
    const tabClick = async (tab) => {
      const index = tab.index
      if (tabs.tabs[index].templateList) {
        return
      }
      tabs.tabs[index].templateList = await queryTemplateList(tabs.tabs[index].id)
    }

    /**
     * 插入模板至编辑器
     */
    const insertContent = inject('insertContent')
    const selectMaterial = (e) => {
      const content = e.currentTarget.cloneNode(true)
      const div = document.createElement('div')
      div.append(content)
      div.append(document.createElement('p'))
      insertContent(div.innerHTML)
    }

    /**
     * 查询分类下的模板
     */
    const queryTemplateList = (id) => {
      return new Promise((resolve) => {
        axios('/admin/desc/template/list', {
          templateGroupId: id
        })
          .then(res => {
            resolve(res.descTemplateList || [])
          }).catch(_ => { })
      })
    }
    onMounted(async () => {
      tabs.tabs[0].templateList = await queryTemplateList(tabs.tabs[0].id)
    })
    return {
      tabs,
      selectMaterial,
      tabClick
    }
  }

}
</script>
<style lang="scss" scoped>
.el-tabs.el-tabs--left :deep{
  .el-tabs__header.is-left {
    margin-right: 5px;
  }
  .el-tabs__item.is-left {
    text-align: center;
    max-width: 80px;
    padding: 0 10px;
    box-sizing: border-box;
    @include single-line-text;
  }
  .el-tabs__content{
    .el-tab-pane {
      display: flex;
      flex-direction: column;
      .title {
        text-align: center;
        line-height: 60px;
        color: $font-gray;
        font-size: $fs14;
        span {
          color: $font-red;
          margin: 0 3px;
        }
      }
      .material-item {
        padding-bottom: 10px;
        border-bottom: 1px dashed $border-gray;
        margin: 0 10px 10px 10px;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
